import * as React from 'react';
import { Input, InputProps } from '@ixicare/ui';
import { ScanButton, ScanIcon } from './ScanButton';
import { ScannerModal, ScanResult } from './ScannerModal';

interface ScannableInputProps extends Omit<InputProps, 'adornment'> {
  /** Receives the parsed scan; the field decides which part it wants. */
  onScan: (result: ScanResult) => void;
  /** Return a message to refuse a scan and keep the camera reading. */
  validateScan?: (result: ScanResult) => string | undefined;
  scanIcon?: ScanIcon;
  scanHint?: string;
}

/** An @ixicare/ui Input with a webcam QR/barcode scanner in its right edge. */
export const ScannableInput: React.FC<ScannableInputProps> = ({
  onScan,
  validateScan,
  scanIcon,
  scanHint,
  ...inputProps
}) => {
  const [isScanning, setIsScanning] = React.useState(false);

  return (
    <>
      <Input
        {...inputProps}
        adornment={<ScanButton onClick={() => setIsScanning(true)} icon={scanIcon} disabled={inputProps.disabled} />}
      />
      {isScanning && (
        <ScannerModal onClose={() => setIsScanning(false)} onScan={onScan} validate={validateScan} hint={scanHint} />
      )}
    </>
  );
};
